"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonReact = require("@devsta/common-react");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function SelectedAssets(_ref) {
  var asset = _ref.asset,
      index = _ref.index,
      lastElement = _ref.lastElement;

  if (!asset) {
    return null;
  }

  return (/*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('bulk-actions__selectedAsset-list__content', {
        'top-margin': index !== 0,
        'no-border': lastElement
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('bulk-actions__selectedAsset-list__content__preview', {
        'bottom-margin': lastElement
      })
    }, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
      height: 80,
      width: 80,
      asset: asset,
      hideFileTypeIcon: true
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "bulk-actions__selectedAsset-list__content__asset-details"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "bulk-actions__selectedAsset-list__content__asset-details__title"
    }, asset && asset.title.toUpperCase()), /*#__PURE__*/_react.default.createElement("p", {
      className: "bulk-actions__selectedAsset-list__content__asset-details__description"
    }, asset && asset.description)))
  );
}

var _default = (0, _commonReact.withAssetSelector)(SelectedAssets);

exports.default = _default;